import React, { ReactNode } from 'react';

import ButtonSimple from '../ButtonSimple';

interface Props {
  icon: ReactNode;
  heightSize?:
    | 'small'
    | 'medium'
    | 'xmedium'
    | 'large'
    | 'xlarge'
    | 'fullHeight';
  widthSize?:
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'xmedium'
    | 'large'
    | 'xlarge'
    | 'fullWidth';
  color: 'primary' | 'gray' | 'success' | 'danger' | 'aqua' | 'transparent';
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}
export default function ButtonIcon({
  icon,
  color,
  disabled,
  onClick,
  widthSize = 'small',
  heightSize = 'fullHeight',
  className,
  type = 'button',
}: Props) {
  return (
    <ButtonSimple
      className={className}
      disabled={disabled}
      color={color}
      widthSize={widthSize}
      heightSize={heightSize}
      onClick={onClick}
      type={type}
    >
      {icon}
    </ButtonSimple>
  );
}
